module.exports = __webpack_public_path__ + "static/media/wx.c9148a87.png";